export default __webpack_public_path__ + "static/media/You-Rock.c80bffc7.gif";